import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'wix-style-react';
import s from './Enterprise.scss';

export const SuccsessMessage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={s.successContainer}>
      <div className={s.successIcon}></div>
      <Text
        dataHook='enterprise-success-message'
        className={s.successMessage}
        size='medium'
      >
        {t('enterprise_plans.request_a_call.notification.success')}
      </Text>
    </div>
  );
};
